export { default, meta } from "./routes/signup._index.tsx";